export const scrollTop = () => {
  const topBtn = document.querySelectorAll(".js-top-btn");
  if (!topBtn.length) return;

  const toggleTopBtn = () => {
    const isVisible = window.scrollY > 200;

    topBtn.forEach((btn) => {
      btn.classList.toggle("is-visible", isVisible);
    });
  };

  toggleTopBtn();
  window.addEventListener("scroll", toggleTopBtn, { passive: true });

  topBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
};
